import { useMutationObserver } from "@vueuse/core";
import { computed, onMounted, ref } from "vue";

/**
 * Whether a wrapper forwards its `no-data` slot to the picker. Remote search shows the picker's own
 * translated empty text unless the caller sets `no-data-text` or slots `no-data` content.
 *
 * @param {object} props  Owning component's reactive props; reads `noDataText`.
 * @param {{ remoteEnabled: import("vue").Ref<boolean>, hostElement: HTMLElement | null,
 *   defaultText: string }} options  `defaultText` is the wrapper's `no-data-text` default.
 * @returns {import("vue").ComputedRef<boolean>}
 */
export function useNoDataForwarding(props, { remoteEnabled, hostElement, defaultText }) {
  const hasNoDataContent = ref(false);

  function readNoDataContent() {
    hasNoDataContent.value = Boolean(hostElement?.querySelector(':scope > [slot="no-data"]'));
  }

  onMounted(readNoDataContent);
  useMutationObserver(hostElement, readNoDataContent, { childList: true });

  return computed(() => !remoteEnabled.value || props.noDataText !== defaultText || hasNoDataContent.value);
}
